import { Component, Input, OnInit, ViewChild } from '@angular/core';
import {
	ControlContainer,
	FormControl,
	FormGroupDirective,
	Validators,
} from '@angular/forms';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { distinctUntilChanged, fromEvent, merge } from 'rxjs';

@Component({
	selector: 'seira-angular-editor',
	templateUrl: './angular-editor.component.html',
	styleUrls: ['./angular-editor.component.scss'],
	viewProviders: [
		{ provide: ControlContainer, useExisting: FormGroupDirective },
	],
})
export class AngularEditorComponent implements OnInit {
	@Input() id!: string;
	@Input() label!: string;
	@Input() required = false;
	@Input() controlName!: string;
	@Input() placeholder!: string;
	@Input() showsTextRequired = false;
	@Input() maxLength?: number;
	mensagemErro?: string;
	control = new FormControl();
	@ViewChild('editor', { static: true }) editor: any;

	editorConfig: AngularEditorConfig = {
		editable: true,
		spellcheck: true,
		height: '15rem',
		minHeight: '5rem',
		translate: 'no',
		placeholder: 'Enter text here...',
		defaultParagraphSeparator: 'p',
		defaultFontName: 'Arial',
		toolbarHiddenButtons: [
			['insertVideo', 'insertImage'],
			['fontSize', 'insertHR', 'removeFormat'],
			['toggleEditorMode'],
		],
	};

	constructor(private controlContainer: ControlContainer) {}

	ngOnInit(): void {
		this.control = this.controlContainer.control?.get(
			this.controlName
		) as FormControl;
		this.ouvirEditor();
	}

	private ouvirEditor(): void {
		const editorElement = this.editor.textArea.nativeElement;
		merge(
			fromEvent(editorElement, 'blur'),
			this.control.valueChanges.pipe(distinctUntilChanged())
		).subscribe(() => {
			if (this.control.errors) {
				const erros = Object.keys(this.control.errors);
				if (erros.length) {
					if (erros[0] === 'required' && this.control.touched) {
						this.mensagemErro = 'Campo obrigatório.';
					} else if (erros[0] === 'maxlengthError') {
						this.mensagemErro = `Limite de ${this.maxLength} caracteres ultrapassado.`;
					} else {
						this.mensagemErro = this.control?.errors[erros[0]]?.label;
					}
				}
			} else {
				this.mensagemErro = '';
			}
		});
	}

	get isRequired(): boolean {
		return !!this.control?.hasValidator(Validators.required);
	}
}
